import React from "react";
import { Row, Col,Image } from "react-bootstrap";
import "./loader.css";
import Loaderimage from "../../assets/images/loader.gif";
import ProgressLine from "./ProgressBar";

const Loader = () => {
  return (
    <>
      <Row>
        <Col sm={4}></Col>
        <Col sm={4}>
          <div className="loader-container">
           <div className="loader">
           <Image src={Loaderimage} style={{ width: "5%" }} />
            
           <ProgressLine
        label=""
        visualParts={[
          {
            percentage: "100%",
            color: "#f50057"
          }
        ]}
      />
       </div>       
          </div>
        </Col>
        <Col sm={4}></Col>
      </Row>
    </>
  );
};

export default Loader;
